import { createConditionRegistry } from './condition-registry'

const createReceivedRequestConditionRegistry = () => {
    const registry = createConditionRegistry()

    registry.register({
        id: 'declaration-approval.required',
        evaluate: context => context.declarationApproval.required === true,
    })
    registry.register({
        id: 'declaration-approval.approved',
        evaluate: context => context.declarationApproval.approved === true,
    })
    registry.register({
        id: 'declaration-approval.pending',
        evaluate: context => (
            context.declarationApproval.required === true
            && context.declarationApproval.approved !== true
        ),
    })
    registry.register({
        id: 'similar-reply-requests.available',
        evaluate: context => (
            ((context.bulkReplyCandidates && context.bulkReplyCandidates.candidates) || []).length > 0
            || (context.bulkReplyCandidates && context.bulkReplyCandidates.error !== null)
        ),
    })

    return registry
}

export { createReceivedRequestConditionRegistry }
export default createReceivedRequestConditionRegistry
